export const HOME = "/";
export const ACADEMY = "/academy";
export const CONTACT_US = "/contact-us";
export const ABOUT_US = "/about-us";
export const SERVICES = "/services";
export const COURSE_DETAILS = "/academy/:id";
export const PLACE_HOLDER = "/images/placeholder.jpeg";
